import { useEffect } from 'react';
import styles from './Login.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import InputText from '../../components/Inputs/InputText/InputText';
import { Formik, Form, Field } from 'formik';
import cx from 'classnames';
import queryString from 'query-string';

import {
  Button,
  Link,
  Notification,
  Card,
  Typography,
} from '@hid-galaxy-ui/galaxy-react';
import * as Yup from 'yup';
import { InputsSchema } from '../../hooks/buildRegisterForm/validationSchema';
import {
  authenticateUser,
  createMyFormMapping,
  getAccountDetails,
} from '../../services/app-user/app-user';
import {
  setLocalStorageItem,
  setSessionStorageItem,
} from '../../utils/sessionUtils';
import {
  isAuthenticated,
  setAuth0LoginResponseToLocalStorage,
} from '../../utils/authService';
import { useHistory } from 'react-router-dom';
import buildPATHS, {
  getFormSessionRedirectUrl,
  getOnlyFormSessionToken,
  getPathWithBaseUrl,
  PATHS_WITH_PARAMS,
} from '../../utils/paths';
import userActions from '../../store/actions/userActions';
import {
  getRegistrationUrl,
  getTranslation,
  isQueryParamsExist,
} from '../../utils/functions';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import InputPassword from '../../components/Inputs/InputPassword/InputPassword';
import { NOTIFICATION_AUTO_CLOSE_DURATION } from '../../constants/common';
import { APP_TYPE } from '../accounts/constant';
import {
  NotificationError,
  NotificationSuccess,
} from '../../utils/notification';
import { IAppProps } from '../../App';
import BoxLogo from '../../components/BoxLogo/BoxLogo';
import { ILoginParams } from '../../services/app-user/IAppUser';
import allActions from '../../store/actions';
import {
  continueAsGuestSelector,
  createAccountEnabledSelector,
  eventIdSelector,
  formDefIdSelector,
  loginEnabledSelector,
  projectIdSelector,
  tenantIdSelector,
} from '../../store/selectors/formSessionSelectors';
import {
  FORM_SESSION_TOKEN_PARAM,
  REDIRECT_TO_PARAM,
} from '../../constants/formParams';
import { getQueryParams } from '../../environments/url-helpers';
import {
  APP_ERRORS,
  BACKEND_RESPONSE_STATUS,
} from '../../constants/backendResponse';
import {
  FORM_SESSION_STATUS,
  FORM_SESSION_VALIDATION_STATUS,
} from '../../utils/formSession';
import { setUserAlreadyAvailableFormPath } from '../../store/actions/appActions';
import { validateFormSessionTokenApi } from '../../services/app-user/app-user';
import { getStatusReasonFromResponse } from '../../utils/apiUtils';
import { PROJECT_REGISTRATION_KEY } from '../../constants/sessionStorage';

const Login = (props: IAppProps) => {
  const { toasts, setToasts } = props;

  const projectId = useSelector(projectIdSelector);
  const formDefId = useSelector(formDefIdSelector);
  const eventId = useSelector(eventIdSelector);
  const tenantId = useSelector(tenantIdSelector);

  const dispatch = useDispatch();

  const history = useHistory();
  const PATHS = buildPATHS();
  const continueAsGuest = useSelector(continueAsGuestSelector);
  const loginEnabled = useSelector(loginEnabledSelector);
  const createAccountEnabled = useSelector(createAccountEnabledSelector);

  useEffect(() => {
    if (isAuthenticated() && !isQueryParamsExist()) {
      history.push(PATHS.my_forms);
    } else if (isAuthenticated() && isQueryParamsExist()) {
      history.push(PATHS.welcome);
    }
  }, []);

  const handleSubmit = async (values: ILoginParams) => {
    dispatch(allActions.appConfigActions.setLoader(true));

    try {
      const payload: ILoginParams = {
        ...values,
      };

      const response = await authenticateUser(payload);
      setAuth0LoginResponseToLocalStorage(response);
      if (response.token) {
        if (projectId && formDefId) {
          validateFormSessionToken();
        }
        const accountDetails = await getAccountDetails();
        dispatch(userActions.setAccountData(accountDetails));
      }
      setToasts([...toasts, ...NotificationSuccess('LOGIN_SUCCESS')]);
      redirectToAppropriatePage();
    } catch (error) {
      setToasts([
        ...toasts,
        ...NotificationError(
          getStatusReasonFromResponse(error) || 'INVALID_CREDENTIALS',
        ),
      ]);
    } finally {
      dispatch(allActions.appConfigActions.setLoader(false));
    }
  };

  const validateFormSessionToken = async () => {
    const sessionToken = getOnlyFormSessionToken();
    try {
      const response = await validateFormSessionTokenApi(tenantId, {
        projectId,
        formDefId,
        ...(eventId && { eventId }),
        ...(sessionToken && { sessionToken }),
      });
      // if (response) {
      //  // myFormMapping();
      // }

      if (
        response?.statusReason ===
        FORM_SESSION_VALIDATION_STATUS.FORM_ALREADY_AVAILABLE
      ) {
        const formSessionToken: any = queryString.parse(response?.formPath)[
          FORM_SESSION_TOKEN_PARAM
        ];

        const formSessionFromToken = formSessionToken
          .split('-')
          .slice(1)
          .join('-');
        dispatch(allActions.appConfigActions.setURLparams(response?.formPath));
        dispatch(
          allActions.formSessionActions.setFormSessionToken(
            formSessionFromToken,
          ),
        );

        history.replace(response?.formPath);

        myFormMapping(response.formPath);

        // window.location.search = response.formPath;
        // dispatch(setUserAlreadyAvailableFormPath(response.formPath));
        // dispatch(allActions.appConfigActions.setAppError(APP_ERRORS.FORM_PENDING));
        // return;
      } else {
        myFormMapping();
      }
    } catch (error) {
      if (
        error.request?.response?.statusReason ===
        BACKEND_RESPONSE_STATUS.USER_ACCOUNT_NOT_APPROVED
      ) {
        dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_NOT_APPROVED,
          ),
        );
      } else if (
        error.request?.response?.statusReason ===
        BACKEND_RESPONSE_STATUS.USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH
      ) {
        dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_DISABILITY_CATEGORY_MISMATCH,
          ),
        );
      } else if (
        error.request?.response?.statusReason ===
        BACKEND_RESPONSE_STATUS.USER_ACCOUNT_REJECTED
      ) {
        dispatch(
          allActions.appConfigActions.setAppError(
            APP_ERRORS.USER_ACCOUNT_REJECTED,
          ),
        );
      }
    }
  };

  const redirectToAppropriatePage = () => {
    const redirectTo = getFormSessionRedirectUrl();
    if (redirectTo) {
      history.push(redirectTo);
    } else {
      history.push(getPathWithBaseUrl(PATHS_WITH_PARAMS.my_forms));
    }

    //   const formSessionToken = getFormSessionToken();
    //   if(formSessionToken) {
    //     history.push(`${PATHS.welcome}?${FORM_SESSION_TOKEN_PARAM}=${formSessionToken}`);
    //   } else {
    //     history.push(redirectTo);
    // }
  };
  // Map anonymous form id with logged in user to display in my forms
  const myFormMapping = async (formPath?: string) => {
    const sessionToken = getOnlyFormSessionToken();
    try {
      const response = await createMyFormMapping({
        projectId,
        formDefId,
        ...(eventId && { eventId }),
        ...(sessionToken && { sessionToken }),
      });

      if (response?.status === FORM_SESSION_STATUS.SUBMITTED) {
        dispatch(
          allActions.appConfigActions.setAppError(APP_ERRORS.FORM_SUBMITTED),
        );
        return;
      }

      if (formPath && response) {
        history.replace(formPath);
        // window.location.search = formPath;
      }

      // if(response?.status === FORM_SESSION_STATUS.PENDING) {
      //   dispatch(setUserAlreadyAvailableFormPath(`${tenantId}-${response.token}`));
      //   dispatch(allActions.appConfigActions.setAppError(APP_ERRORS.FORM_PENDING));
      //   return;

      // }
    } catch (error) {
      console.error(error);
    }
  };

  const buildFormValidation = () => {
    return Yup.object().shape({
      email: InputsSchema.EMAIL({
        required: true,
        properties: {
          errorMessageRequired: 'EMAIL_REQUIRED',
          label: 'EMAIL',
        },
      }),

      password: InputsSchema.TEXTFIELD({
        required: true,
        properties: {
          errorMessageRequired: 'PASSWORD_REQUIRED',
        },
      }),
    });
  };

  const handleRegisterClick = () => {
    redirectToUrl(getRegistrationUrl(), PATHS.account_register);
  };

  const handleGuestClick = () => {
    setSessionStorageItem('isLoginFlowModalClosed', true);
    history.push(PATHS.welcome);
  };

  const handleForgotPasswordClick = () => {
    redirectToUrl(
      getPathWithBaseUrl(PATHS_WITH_PARAMS.forgot_password),
      PATHS.forgot_password,
    );
  };

  const redirectToUrl = (url: string, queryParamurl = null) => {
    if (isQueryParamsExist() && queryParamurl) {
      history.push(queryParamurl);
    } else {
      history.push(url);
    }
  };

  return (
    <div className={styles.formWrapper}>
      <Card className={styles.card}>
        <Formik
          initialValues={{ email: undefined, password: '' }}
          validationSchema={buildFormValidation()}
          onSubmit={handleSubmit}
        >
          {({}) => (
            <>
              <Form
                className={cx(
                  'hid-spacing__py-06',
                  'hid-spacing__px-03',
                  'login-form',
                )}
              >
                <BoxLogo />
                <Typography
                  className="hid-text-center hid-spacing__mb-04"
                  variant={TypographyVariantEnum.H2}
                >
                  {getTranslation('SIGN_IN_MSG')}
                </Typography>
                <Field
                  key="email"
                  component={InputText}
                  label={getTranslation('EMAIL')}
                  type="email"
                  name="email"
                  id="email"
                  required={true}
                />
                <Field
                  key="password"
                  component={InputPassword}
                  label={getTranslation('PASSWORD')}
                  name="password"
                  id="password"
                  required={true}
                />

                <div className="hid-flex hid-flex-row hid-flex-jc-between hid-text-center hid-spacing__mt-07">
                  {createAccountEnabled && (
                    <Button
                      onClick={() => handleRegisterClick()}
                      variant="secondary"
                      label={getTranslation('CREATE_ACCOUNT')}
                    />
                  )}
                  {loginEnabled && (
                    <Button label={getTranslation('LOGIN')} type="submit" />
                  )}
                </div>
                <div className="hid-flex hid-flex-jc-between hid-spacing__mt-07">
                  {isQueryParamsExist() && continueAsGuest && (
                    <Link onClick={() => handleGuestClick()}>
                      <Typography variant={TypographyVariantEnum.H3}>
                        {getTranslation('CONTINUE_AS_GUEST')}
                      </Typography>
                    </Link>
                  )}

                  {loginEnabled && (
                    <Link
                      onClick={() => {
                        handleForgotPasswordClick();
                      }}
                    >
                      <Typography variant={TypographyVariantEnum.H3}>
                        {getTranslation('FORGOT_PASSWORD')}
                      </Typography>
                    </Link>
                  )}
                </div>
              </Form>
            </>
          )}
        </Formik>
      </Card>
      <Notification
        toasts={toasts}
        setToasts={setToasts}
        autoClose={NOTIFICATION_AUTO_CLOSE_DURATION}
      />
    </div>
  );
};

export default Login;
